module.exports = __webpack_public_path__ + "img/online-ship.c68f83cc.svg";